module.exports = __webpack_public_path__ + "img/G2.460ec49d.png";